import { render, staticRenderFns } from "./teacherPickerDialog.vue?vue&type=template&id=d0821f00"
import script from "./teacherPickerDialog.vue?vue&type=script&lang=ts"
export * from "./teacherPickerDialog.vue?vue&type=script&lang=ts"
import style0 from "./teacherPickerDialog.vue?vue&type=style&index=0&id=d0821f00&prod&lang=css"
import style1 from "@/components/acquisitionList/ui/acquisitionViews.css?vue&type=style&index=1&prod&lang=css&external"
import style2 from "@/components/common/modern/modern.css?vue&type=style&index=2&prod&lang=css&external"
import style3 from "@/components/common/modern/modernDialog.css?vue&type=style&index=3&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports